export enum TableStatus {
  AVAILABLE = 'AVAILABLE', // 🟢 Libre
  OCCUPIED = 'OCCUPIED', // 🔵 Ocupada
  ORDER_IN_PROGRESS = 'ORDER_IN_PROGRESS', // 🟡 Pedido en curso
  SERVING = 'SERVING', // 🟠 Sirviendo
  PENDING_PAYMENT = 'PENDING_PAYMENT', // 🔴 Pendiente de pago
}

export const TABLE_STATUS_COLORS = {
  [TableStatus.AVAILABLE]: 'var(--status-available)',
  [TableStatus.OCCUPIED]: 'var(--status-occupied)',
  [TableStatus.ORDER_IN_PROGRESS]: 'var(--status-in-progress)',
  [TableStatus.SERVING]: 'var(--status-serving)',
  [TableStatus.PENDING_PAYMENT]: 'var(--status-pending-payment)',
};

export const TABLE_STATUS_LABELS = {
  [TableStatus.AVAILABLE]: 'Libre',
  [TableStatus.OCCUPIED]: 'Ocupada',
  [TableStatus.ORDER_IN_PROGRESS]: 'Pedido en curso',
  [TableStatus.SERVING]: 'Sirviendo',
  [TableStatus.PENDING_PAYMENT]: 'Pendiente de pago',
};
